module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av670-96d684576104dadceeecaed1391dd597.jpg";